import styled from 'styled-components';
import { animated } from 'react-spring';
import { COLORS } from '../../../styles/variables';
import { device } from '../../../styles/devices';

export const ExteriorFilterFrame = styled(animated.div)`
  padding: 24px;
`;

export const ExteriorListWrapper = styled.div`
  display: flex;
  font-family: Audi Type;
  justify-content: space-between;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px 48px;
  @media ${device.tablet} {
    gap: 13px;
  }
  flex: 1 0 0;
  flex-wrap: wrap;
`;

export const OptionWrapper = styled.button<{ isSelected?: boolean }>`
  border: none;
  background-color: transparent;
  font-family: Audi Type;
  display: flex;
  padding: 2px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  outline: ${({ isSelected }) => isSelected && `2px solid ${COLORS.black}`};
  :focus {
    outline: ${({ isSelected }) => isSelected && `2px solid ${COLORS.black}`};
  }
  :hover {
    outline: 1px solid ${COLORS.grey70};
  }
`;

export const Image = styled.img`
  width: 65px;
  height: 65px;
`;

export const Label = styled.div`
  font-family: Audi Type;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.003px;
`;
